/** Shared slug → public /turku/ path (matches Cloudflare Functions canonical URLs). */

export function normalizeTurkuSlugKey(slug: string): string {
  let s = slug.trim();
  if (!s) return s;
  if (/%[0-9A-Fa-f]{2}/.test(s)) {
    try {
      s = decodeURIComponent(s);
    } catch {
      /* keep s */
    }
  }
  return s.normalize("NFC");
}

/** Next.js RSC / static export paths — not real turku slugs. */
const NON_TURKU_SLUG_SEGMENTS = new Set(["index", "index.txt", "index.html"]);

export function isInvalidTurkuSlug(slug: string): boolean {
  const key = normalizeTurkuSlugKey(slug).toLowerCase();
  return !key || NON_TURKU_SLUG_SEGMENTS.has(key);
}

/** Canonical public türkü URL (locale-free; no trailing slash — matches GSC canonical). */
export function turkuSongPath(slug: string): string {
  const segment = encodeURIComponent(normalizeTurkuSlugKey(slug));
  return `/turku/${segment}`;
}
